import { render, staticRenderFns } from "./DuelsControls.vue?vue&type=template&id=00b1b361&scoped=true"
import script from "./DuelsControls.vue?vue&type=script&lang=js"
export * from "./DuelsControls.vue?vue&type=script&lang=js"
import style0 from "./DuelsControls.vue?vue&type=style&index=0&id=00b1b361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1b361",
  null
  
)

export default component.exports